// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"5d9f672c","752":"3e1d6852"}[chunkId] + ".chunk.js";
};